module.exports = __webpack_public_path__ + "static/media/logos_squares_Diamond_Towngas.fe7e421d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Diamond_Towngas.png
// module id = 78
// module chunks = 0